export const MAILBOX_JUST_CONNECTED_KEY = "mailbox_just_connected";
